<template name="dialog-confirm">
	<div class="add-dailybill-dialog">
		<el-dialog
		  title="销售数据录入"
		  :visible.sync="show"
		  :before-close="_close"
		  :close-on-click-modal="false"
		>
			<el-row>
				<el-col>
					<el-form class="myform" :model="formData" :rules="formRule" ref="ruleForm" label-width="110px">
			
						<el-form-item label="渠道名称">
							<div class="form-item">
								{{info.name}}
							</div>
						</el-form-item>
			
						<el-form-item label="销售时间" prop="bill_date">
							<div class="form-item">
								<el-date-picker class="bill_input" type="date" v-model="formData.bill_date" value-format="yyyy-MM-dd" placeholder="选择时间">
								</el-date-picker>
							</div>
						</el-form-item>
						
						<el-form-item label="销售笔数" prop="order_num">
							<div class="form-item">
								<el-input class="bill_input" v-model="formData.order_num" placeholder="输入订单数" maxlength="10" @input="_inputChange($event, 'order_num')">
								</el-input>
							</div>
						</el-form-item>
						
						<el-form-item label="销售金额" prop="amount">
							<div class="form-item">
								<el-input class="bill_input" v-model="formData.amount" placeholder="输入当天销售金额" maxlength="10" @input="_inputChange($event, 'amount')">
								</el-input>
							</div>
						</el-form-item>
						
						<el-form-item label="分润比例">
							<div class="form-item">
								{{info.def_rate}}%
							</div>
						</el-form-item>
						
						<el-form-item label="分佣金额" prop="commission">
							<div class="form-item">
								<el-input class="bill_input" v-model="formData.commission" placeholder="¥0.00" maxlength="10" @input="_inputChange($event, 'commission')">
								</el-input>
							</div>
						</el-form-item>
			
						<div class="form-handle">
							<el-button type="infor" @click="_close()">取消</el-button>
							<el-button type="primary" @click="_save()" :loading="submiting">确定</el-button>
						</div>
					</el-form>
				</el-col>
			</el-row>
		
		</el-dialog>
	</div>
</template>

<script>
	import {
		addBill,
		getBillBaseInfo
	} from '@/api/channel';
	export default {
		data() {
			return {
				submiting: false,
				info:[],
				formData: {
					bill_date: '',
					order_num: '',
					amount: '',
					commission: '',
				},
				formRule: {
					bill_date: [{
						required: true,
						message: '请选择销售时间'
					}],
					order_num: [{
						required: true,
						message: '请输入订单销售笔数'
					}],
					amount: [{
						required: true,
						message: '请输入销售金额',
					}],
					commission: [{
						required: true,
						message: '请输入分佣金额',
					}]
				},
			};
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
			channel_id: {
				type: Number,
				default: 0,
			},
		},
		watch:{
			show: function(newVal, oldVal){
				if(newVal){
					this._getInfo();
				}
			}
		},
		methods: {
			_close() {
				this._clear();
				this.$emit('close');
			},
			_clear(){
				this.info = [];
				this.submiting = false;
				this.$refs['ruleForm'].resetFields();
			},
			_save(){
				var that = this;
				var info = that.formData;
				if (this.submiting) {
					return false;
				}
				
				if (that.formData.amount > 99999999) {
					this.$message.error("销售金额不能超过99999999");
					return false;
				}
				if (that.formData.commission > 99999999) {
					this.$message.error("分佣金额不能超过99999999");
					return false;
				}
				
				that.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						info.channel_id = that.channel_id;
						
						that.submiting = true; 
						addBill(info).then(res => {
							if (res.code == 0) {
								that.$message.success('添加成功');
								that._clear();
								that.$emit('success');
							}else{
								that.$message.error(res.message);
								that.submiting = false;
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			_getInfo() {
				getBillBaseInfo({
					channel_id: this.channel_id
				}).then(res => {
					if (res.code == 0) {
						res.data.def_rate = parseFloat(res.data.def_rate)
						this.info = res.data;
					} else {
						this.$message.error(res.message);
					}
				})
			},
			_inputChange(event, model) {
				var value = '' + event;
				value = value.replace(/\s/g, "");
				switch (model) {
					case 'order_num':
						value = value.replace(/[^\d]/g, "");
						value = value ? Number(value) : '';
						this.formData[model] = value;
						break;
					case 'amount':
						value = num(value);
						this.formData[model] = value;
						this._calulate();
						break;
					case 'commission':
						value = num(value);
						this.formData[model] = value;
						break;
				}
			},
			// 自动计算佣金
			_calulate(){
				let amount = this.formData.amount;
				let rate = this.info.def_rate;
				
				let commission = (amount * (rate / 100)).toFixed(3);
				commission = Math.round(commission * 100) / 100;
				if (this.formData.commission > 0 || commission > 0) this.formData.commission = commission;
			}
		},
		mounted() {
		}
	}
	
	function num(value) {
		value = value.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
		value = value.replace(/^\./g, ""); //验证第一个字符是数字
		value = value.replace(/\.{2,}/g, "."); //只保留第一个, 清除多余的
		value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
		value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
		var smPric = /^\d{0,10}(\.\d{0,2})?$/;
		
		if (!smPric.test(value)) {
			return '';
		}
		return value;
	}
</script>

<style>
	.add-dailybill-dialog .el-dialog__body {
		padding-top: 0;
		padding-bottom: 16px;
		height: 470px;
		overflow-x: auto;
		font-size: 14px;
	}
	.add-dailybill-dialog .el-dialog {
		width: 500px;
	}
	.add-dailybill-dialog .el-row{
		margin-top: 20px;
	}
	.add-dailybill-dialog .el-form-item__error{
		left: 20px;
	}
	
	.add-dailybill-dialog .el-form-item__label{
		font-weight: bold;
		margin-right: 20px;
	}
	.add-dailybill-dialog .bill_input{
		width: 284px;
	}
	.add-dailybill-dialog .form-handle{
		text-align: right;
		margin-top: 30px;
	}
	.add-dailybill-dialog .form-handle button{
		width: 80px;
	}
</style>